"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleChecked = exports.filterColumnSelectorItems = exports.sortColumnSelectorItems = void 0;
const sortColumnSelectorItems = (items, orderedKeys) => {
    const sortedCheckedItems = items
        .filter((item) => item.checked)
        .sort((a, b) => orderedKeys.indexOf(a.columnId) - orderedKeys.indexOf(b.columnId));
    const sortedNonCheckedItems = items
        .filter((item) => !item.checked)
        .sort((a, b) => {
        if (a.label > b.label) {
            return 1;
        }
        if (a.label < b.label) {
            return -1;
        }
        return 0;
    });
    return [...sortedCheckedItems, ...sortedNonCheckedItems];
};
exports.sortColumnSelectorItems = sortColumnSelectorItems;
const filterColumnSelectorItems = (items, searchTerm) => {
    if (!searchTerm)
        return items;
    return items.filter((item) => item.label.toLowerCase().trim().startsWith(searchTerm.toLowerCase().trim()));
};
exports.filterColumnSelectorItems = filterColumnSelectorItems;
const toggleChecked = (items, index) => {
    const updatedItems = [...items];
    if (updatedItems[index].checked) {
        updatedItems[index].checked = false;
    }
    else {
        updatedItems[index].checked = true;
    }
    return updatedItems;
};
exports.toggleChecked = toggleChecked;
